import axiosInstance from "../../../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../../../Utils/paginationParam";
let cancelToken;

const saleReturnURL = `api/v1/sales-app/sales-order-return`;

//obtaining the paginated data
export const getSaleReturn = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleReturnURL}/list?party_type=customer&${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};

//obtaining all fiscal sessions
export const getAllSaleReturn = () => axiosInstance.get(`${saleReturnURL}/list?party_type=customer&ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSaleReturn = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(
    `${saleReturnURL}/list?party_type=customer&${paginationQueryParams(rowsPerPage, search, "", number)}`
  );
// get by id
export const getSaleReturnById = (id) => axiosInstance.get(`${saleReturnURL}/retrieve/${id}`);

// get invoice details
export const getSaleInvoiceDetail = (id) => axiosInstance.get(`api/v1/sales-app/sales-invoice/retrieve-for-sale-return/${id}`);

export const getSaleReturnAdditionalChargeList = () =>
  axiosInstance.get(`api/v1/core-app/additional-charge/list?is_active=true`);

//creating function
export const createSaleReturn = (body) => axiosInstance.post(`${saleReturnURL}/create`, body);
//updating function
export const updateSaleReturn = (id, body) => axiosInstance.patch(`${saleReturnURL}/update/${id}`, body);

//approve function
export const approveSaleReturn = (id) => axiosInstance.patch(`${saleReturnURL}/approve/${id}`);

// cancel function
export const cancelSaleReturn = (id) => axiosInstance.patch(`${saleReturnURL}/cancel/${id}`);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(
    `${saleReturnURL}/list?party_type=customer&offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`,
    {
      cancelToken: cancelToken.token,
    }
  );
};
